import React, {useState} from 'react';
import PersonalSchedule from './PersonalSchedule';
import ScheduleStaffs from './ScheduleStaffs';

export default function WorkSchedulePage() {
    const [view, setView] = useState<'personal' | 'team'>('personal');

    return view === 'team'
        ? <ScheduleStaffs onShowPersonal={() => setView('personal')}/>
        : <PersonalSchedule onShowTeam={() => setView('team')}/>;
}
